import React, { useCallback } from "react";
import { WorkflowTriggerType } from "../../../../__generated__/api";
import Styles from "./Actions.module.scss";
import Button from "../../../../components/theme/button/Button";
import Icon from "../../../../components/theme/icon/Icon";
import Text from "../../../../components/theme/text/Text";
import WORKFLOW_TRIGGER_TYPES from "./WorkflowTriggerTypes";

export default function CreateAutomation({ onSelect }: { onSelect: (type: WorkflowTriggerType) => void }) {
    const handleSelectAutomationType = useCallback((type: WorkflowTriggerType) => {
        onSelect(type);
    }, [onSelect]);

    return (
        <div className={Styles["create-from-scratch"]}>
            <Text textVariant="subtitle-3" as="h3">Select Automation Type:</Text>
            <div className={Styles["automation-create-list"]}>
                {Object.values(WORKFLOW_TRIGGER_TYPES).sortBy(type => type.createOrder).filterMap(type => (
                    <div className={Styles["automation-create-item"]} key={type.value}>
                        <Icon size="xlarge" icon={type.icon} isRounded variant="primary" background="primary" />
                        <Text
                            textVariant="body-1-semibold"
                            as="div"
                            className={Styles["automation-create-item-title"]}
                        >
                            {type.text}
                        </Text>
                        <Text as="p" textVariant="body-2-regular" colorVariant="body-secondary">{type.description}</Text>
                        <Button variant="outline-gray" onClick={() => handleSelectAutomationType(type.value)}>Select</Button>
                    </div>

                ), type => type.canCreate !== false)}

            </div>
        </div>
    );
}
